import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../api/auth/useAuth";
import { resolvePostAuthDestination } from "./authReturn";
import { LoadingSpinner } from "./LoadingSpinner";

export const PublicRoute = () => {
  const { token, isRestored } = useAuth();
  const location = useLocation();

  // Don't decide before the stored session has been read.
  if (!isRestored) return <LoadingSpinner />;

  // A session on an auth screen means login or signup just finished.
  // Send the user back to the page that opened the form.
  return token ? (
    <Navigate to={resolvePostAuthDestination(location)} replace />
  ) : (
    <Outlet />
  );
};
